"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatmapRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var mobx_react_1 = require("mobx-react");
var HeatmapCell_view_1 = require("./HeatmapCell_view");
var HeatmapHeader_view_1 = require("./HeatmapHeader_view");
//#region INTERNAL FUNCTIONS
var style = function (headers) {
    return {
        width: HeatmapHeader_view_1.HEATMAP_CELL_WIDTH * headers.length
    };
};
var findCell = function (data, headerElement, row) {
    var result = data.find(function (e) {
        return ("".concat(e.xAxisKey) === "".concat(headerElement.columnKey)
            &&
                "".concat(e.yAxisKey) === "".concat(row.rowKey));
    });
    return result;
};
var MappedCells = (0, mobx_react_1.observer)(function (_a) {
    var row = _a.row, headers = _a.headers, model = _a.model;
    return (headers.map(function (e, i) {
        var cell = findCell(model.heatmapData, e, row);
        return ((0, jsx_runtime_1.jsx)(HeatmapCell_view_1.Cell, { cell: cell, model: model }, "".concat(row.rowKey, "_").concat(e.columnKey, "_").concat(i)));
    }));
});
//#endregion
var HeatmapRow = (0, mobx_react_1.observer)(function (_a) {
    var row = _a.row, headers = _a.headers, model = _a.model;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "heatmap__row", style: style(headers) }, { children: (0, jsx_runtime_1.jsx)(MappedCells, { headers: headers, row: row, model: model }) })));
});
exports.HeatmapRow = HeatmapRow;
